import React from 'react';

const PlusIcon = () => <>&#43;</>;

export default PlusIcon;
